import useAPI from '@/hooks/useAPI';
import WorkRepository from '@/repositories/WorkRepository';

const useWorkGroups = () => {
  const workRepo = WorkRepository();

  return useAPI({
    queryKey: ['getWorkGroups'],
    queryFn: async () => await workRepo.getWorkGroups()
  });
};

export default useWorkGroups;
